module.exports = __webpack_public_path__ + "img/sUSDT_256.d6a29501.png";